import styled, { css } from 'styled-components'

interface EllipseContainerPositionProps {
  position: number
}

export const EllipseContainerPosition = styled.button<EllipseContainerPositionProps>`
  position: absolute;
  left: ${props => props.position}%;
  top: 50%;
  ${props =>
    props.position <= 50
      ? css`
          transform: translateY(-50%);
        `
      : css`
          transform: translate(-100%, -50%);
        `};
  border: none;
  border-radius: 50%;
  &:focus {
    filter: drop-shadow(0px 0px 1px #000);
    outline: none;
  }
  &:hover {
    z-index: 1000;
  }
`
